/**
 * The two notification addresses, stated once.
 *
 * ★ `/notifications/preferences` IS READ FROM OUTSIDE THIS APP. Every monthly statement e-mail
 * prints it as its unsubscribe path, built from the server's own constant
 * (`CABINET_NOTIFICATION_PREFERENCES_PATH`, src/modules/notifications/worker/cabinet-origin.provider.ts),
 * which says "A client that routes differently changes this one constant". So this value must stay
 * equal to that one: `test/routes/notifications/preferences-path.spec.ts` reads the server's file
 * and fails the day the two part.
 */
export const NOTIFICATIONS_PATH = '/notifications';
export const NOTIFICATION_PREFERENCES_PATH = '/notifications/preferences';
